// extracted by mini-css-extract-plugin
export default {"container":"CarouselItem_container__DlrSx","imageWrapper":"CarouselItem_imageWrapper__X1H8-","image":"CarouselItem_image__c96Bx","content":"CarouselItem_content__jk1pA"};